import React, { useEffect, useState } from 'react';
import api from '../api';
import FlowEditor from '../components/FlowEditor';
import BotCommands from '../components/BotCommands';
import AIFlowGenerator from '../components/AIFlowGenerator';
import PageHeader from '../components/PageHeader';
import { Avatar, Ic, fmtNum } from '../components/ui';

const EMPTY = { name: '', token: '', description: '', ticket_mode: false, ticket_welcome: '', ticket_auto_reply: '', ai_enabled: false, ai_api_key: '', ai_model: '' };

export default function Bots() {
  const [bots, setBots] = useState([]);
  const [showFlows, setShowFlows] = useState(null);
  const [showCommands, setShowCommands] = useState(null);
  const [showAIFlow, setShowAIFlow] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editBot, setEditBot] = useState(null);
  const [webhookStatus, setWebhookStatus] = useState({});
  const [webhookLoading, setWebhookLoading] = useState({});
  const [toast, setToast] = useState(null);
  const [form, setForm] = useState(EMPTY);

  useEffect(() => { loadBots(); }, []);

  async function loadBots() { try { const r = await api.get('/bots'); setBots(r.data); loadWebhookStatus(); } catch (e) { /* noop */ } }
  async function loadWebhookStatus() {
    try { const r = await api.get('/webhook-manager/status'); const map = {}; r.data.forEach(s => { map[s.bot_id] = s; }); setWebhookStatus(map); } catch (e) { /* noop */ }
  }
  async function registerWebhook(botId) {
    setWebhookLoading(l => ({ ...l, [botId]: true }));
    try { const r = await api.post(`/webhook-manager/${botId}/register`); showMsg(true, r.data.message || 'Webhook bağlandı'); loadWebhookStatus(); loadBots(); }
    catch (e) { showMsg(false, e.response?.data?.error || e.message); }
    setWebhookLoading(l => ({ ...l, [botId]: false }));
  }
  async function unregisterWebhook(botId) {
    if (!window.confirm('Webhook kaldırılsın mı?')) return;
    setWebhookLoading(l => ({ ...l, [botId]: true }));
    try { await api.delete(`/webhook-manager/${botId}/unregister`); showMsg(true, 'Webhook kaldırıldı'); loadWebhookStatus(); }
    catch (e) { showMsg(false, e.response?.data?.error || e.message); }
    setWebhookLoading(l => ({ ...l, [botId]: false }));
  }
  async function registerAll() {
    showMsg(true, 'Bağlanıyor…');
    try { const r = await api.post('/webhook-manager/register-all'); showMsg(true, `${r.data.success_count}/${r.data.total} bot bağlandı`); loadWebhookStatus(); }
    catch (e) { showMsg(false, e.response?.data?.error || e.message); }
  }
  function showMsg(ok, text) { setToast({ ok, text }); setTimeout(() => setToast(null), 4500); }

  function openCreate() { setEditBot(null); setForm(EMPTY); setShowForm(true); }
  function openEdit(bot) {
    setEditBot(bot);
    setForm({ name: bot.name || '', token: bot.token || '', description: bot.description || '', ticket_mode: bot.ticket_mode || false, ticket_welcome: bot.ticket_welcome || '', ticket_auto_reply: bot.ticket_auto_reply || '', ai_enabled: bot.ai_enabled || false, ai_api_key: bot.ai_api_key || '', ai_model: bot.ai_model || '' });
    setShowForm(true);
  }
  async function saveBot(e) {
    e.preventDefault();
    try {
      if (editBot) { await api.put(`/bots/${editBot.id}`, form); showMsg(true, 'Güncellendi'); }
      else { await api.post('/bots', form); showMsg(true, 'Bot eklendi'); }
      setShowForm(false); loadBots();
    } catch (err) { showMsg(false, err.response?.data?.error || err.message); }
  }
  async function toggleActive(bot) { try { await api.patch(`/bots/${bot.id}/toggle`); loadBots(); } catch (e) { /* noop */ } }
  async function deleteBot(bot) {
    if (!window.confirm(`"${bot.name}" silinsin mi?`)) return;
    try { await api.delete(`/bots/${bot.id}`); showMsg(true, 'Silindi'); loadBots(); } catch (e) { /* noop */ }
  }

  if (showCommands) return (
    <div className="page-enter">
      <div className="flex-center gap-10" style={{ marginBottom: 18 }}>
        <button className="btn btn-icon" onClick={() => setShowCommands(null)} title="Geri"><Ic n="back" /></button>
        <Avatar id={showCommands.id} name={showCommands.name} size={38} />
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 17, fontWeight: 700 }} className="truncate">{showCommands.name}</div>
          <div className="text-muted" style={{ fontSize: 13 }}>Komutlar</div>
        </div>
      </div>
      <BotCommands botId={showCommands.id} botName={showCommands.name} />
    </div>
  );
  if (showFlows) return <FlowEditor bot={showFlows} onBack={() => { setShowFlows(null); loadBots(); }} />;

  const activeCount = bots.filter(b => b.is_active).length;
  const webhookCount = Object.values(webhookStatus).filter(s => s.has_webhook).length;
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div className="page-enter">
      {showAIFlow && <AIFlowGenerator bot={showAIFlow} onFlowCreated={() => {}} onClose={() => setShowAIFlow(null)} />}
      {toast && (
        <div style={{ position: 'fixed', left: '50%', bottom: 24, transform: 'translateX(-50%)', zIndex: 9999, background: 'rgba(0,0,0,.85)', color: '#fff', borderRadius: 10, padding: '10px 16px', fontSize: 14, display: 'flex', alignItems: 'center', gap: 8, maxWidth: '90vw' }}>
          <Ic n={toast.ok ? 'checkCircle' : 'alert'} s={18} c={toast.ok ? 'var(--success)' : 'var(--danger)'} />{toast.text}
        </div>
      )}

      <PageHeader
        title="Botlar"
        subtitle="Telegram botlarını yönet ve yapılandır"
        actions={<>
          <button className="btn btn-ghost" onClick={() => { loadBots(); }}><Ic n="refresh" s={16} />Yenile</button>
          <button className="btn btn-ghost" onClick={registerAll}><Ic n="link" s={16} />Tümüne webhook</button>
          <button className="btn btn-primary" onClick={openCreate}><Ic n="plus" s={18} />Bot ekle</button>
        </>}
      />

      <div className="stats-grid">
        {[
          { l: 'Toplam bot', v: bots.length, c: 'var(--link)', i: 'bot' },
          { l: 'Aktif', v: activeCount, c: 'var(--success)', i: 'play' },
          { l: 'Webhook bağlı', v: webhookCount, c: 'var(--info)', i: 'link' },
          { l: 'Pasif', v: bots.length - activeCount, c: 'var(--text3)', i: 'pause' },
        ].map(s => (
          <div key={s.l} className="stat-card">
            <div className="stat-ic" style={{ background: 'var(--surface3)', color: s.c }}><Ic n={s.i} s={17} /></div>
            <div className="stat-value" style={{ color: s.c }}>{s.v}</div>
            <div className="stat-label">{s.l}</div>
          </div>
        ))}
      </div>

      {bots.length === 0 ? (
        <div className="card"><div className="empty-state"><div className="icon"><Ic n="bot" s={44} /></div><p>Henüz bot eklenmedi</p><button className="btn btn-primary mt-12" onClick={openCreate}>İlk botu ekle</button></div></div>
      ) : (
        <div className="bots-grid">
          {bots.map(bot => {
            const ws = webhookStatus[bot.id];
            const hasWebhook = ws?.has_webhook;
            const busy = webhookLoading[bot.id];
            return (
              <div key={bot.id} className="card" style={{ padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column', opacity: bot.is_active ? 1 : 0.8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 14px 10px' }}>
                  <Avatar id={bot.id} name={bot.name} size={48} style={{ filter: bot.is_active ? 'none' : 'grayscale(.7)' }}>{bot.bot_type === 'date' ? <Ic n="heart" s={24} /> : null}</Avatar>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="truncate" style={{ fontWeight: 700, fontSize: 15.5 }}>{bot.name}</div>
                    <div className="flex gap-6" style={{ flexWrap: 'wrap', marginTop: 3 }}>
                      <span className="text-muted" style={{ fontSize: 13 }}>{fmtNum(bot.user_count)} kullanıcı</span>
                      {bot.ticket_mode && <span className="badge badge-warning">Ticket</span>}
                      {bot.ai_enabled && <span className="badge badge-info">YZ</span>}
                    </div>
                  </div>
                  <label className="toggle" title={bot.is_active ? 'Durdur' : 'Başlat'}>
                    <input type="checkbox" checked={!!bot.is_active} onChange={() => toggleActive(bot)} /><span className="toggle-slider" />
                  </label>
                </div>

                <div style={{ margin: '0 14px', display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', borderRadius: 10, background: !ws ? 'var(--surface3)' : hasWebhook ? 'var(--success-s)' : 'var(--danger-s)' }}>
                  <span className={'dot ' + (!ws ? 'dot-gray' : hasWebhook ? 'dot-green' : 'dot-red')} />
                  <span style={{ flex: 1, fontSize: 13, fontWeight: 600, color: !ws ? 'var(--text3)' : hasWebhook ? 'var(--success)' : 'var(--danger)' }}>
                    {!ws ? 'Kontrol ediliyor…' : hasWebhook ? 'Webhook bağlı' : 'Webhook bağlı değil'}
                  </span>
                  {ws?.pending_count > 0 && <span className="badge badge-warning">{ws.pending_count} bekleyen</span>}
                  <button className={'btn btn-xs ' + (hasWebhook ? 'btn-ghost' : 'btn-success')} disabled={busy} onClick={() => (hasWebhook ? unregisterWebhook(bot.id) : registerWebhook(bot.id))}>
                    {busy ? '…' : hasWebhook ? 'Kaldır' : 'Bağla'}
                  </button>
                </div>
                {ws?.last_error && <div style={{ margin: '6px 14px 0', fontSize: 12, color: 'var(--danger)' }} className="truncate" title={ws.last_error}>⚠ {ws.last_error}</div>}

                <div className="mono" style={{ margin: '8px 14px 0', fontSize: 12, color: 'var(--text3)' }}>{bot.token ? `${bot.token.substring(0, 12)}…${bot.token.slice(-5)}` : ''}</div>

                <div className="keep-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0,1fr))', gap: 6, padding: 14 }}>
                  <button className="btn btn-sm btn-teal" onClick={() => setShowFlows(bot)}><Ic n="flow" s={16} />Flow</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => setShowAIFlow(bot)} style={{ color: 'var(--purple)' }}><Ic n="sparkle" s={16} />AI Flow</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => setShowCommands(bot)}><Ic n="keyboard" s={16} />Komut</button>
                </div>

                <div style={{ display: 'flex', borderTop: '1px solid var(--border3)', marginTop: 'auto' }}>
                  <button className="btn btn-sm" style={{ flex: 1, borderRadius: 0, background: 'none', color: 'var(--text2)' }} onClick={() => openEdit(bot)}><Ic n="edit" s={15} />Düzenle</button>
                  <button className="btn btn-sm" style={{ flex: 1, borderRadius: 0, background: 'none', color: 'var(--danger)', borderLeft: '1px solid var(--border3)' }} onClick={() => deleteBot(bot)}><Ic n="trash" s={15} />Sil</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {showForm && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowForm(false)}>
          <div className="modal" style={{ maxWidth: 560, width: '100%' }}>
            <h3>{editBot ? 'Botu düzenle' : 'Yeni bot ekle'}</h3>
            <form onSubmit={saveBot}>
              <div className="form-2">
                <div className="input-group"><label>Bot adı *</label><input className="input" value={form.name} onChange={e => set('name', e.target.value)} placeholder="mybot" required /></div>
                <div className="input-group"><label>Bot token *</label><input className="input" value={form.token} onChange={e => set('token', e.target.value)} placeholder="123456:ABC…" required /></div>
              </div>
              <div className="input-group"><label>Açıklama</label><input className="input" value={form.description} onChange={e => set('description', e.target.value)} placeholder="Bot hakkında not…" /></div>

              <div style={{ background: 'var(--bg2)', borderRadius: 12, padding: 14, marginBottom: 12 }}>
                <label className="flex-center gap-10" style={{ cursor: 'pointer' }}>
                  <span className="toggle"><input type="checkbox" checked={form.ticket_mode} onChange={e => set('ticket_mode', e.target.checked)} /><span className="toggle-slider" /></span>
                  <span style={{ fontWeight: 600 }}>Ticket modu</span>
                </label>
                {form.ticket_mode && <>
                  <div className="input-group" style={{ marginTop: 12 }}><label>Karşılama mesajı</label><textarea className="input" value={form.ticket_welcome} onChange={e => set('ticket_welcome', e.target.value)} style={{ minHeight: 60 }} /></div>
                  <div className="input-group" style={{ marginBottom: 0 }}><label>Otomatik yanıt</label><textarea className="input" value={form.ticket_auto_reply} onChange={e => set('ticket_auto_reply', e.target.value)} style={{ minHeight: 50 }} /></div>
                </>}
              </div>

              <div style={{ background: 'var(--bg2)', borderRadius: 12, padding: 14, marginBottom: 18 }}>
                <label className="flex-center gap-10" style={{ cursor: 'pointer' }}>
                  <span className="toggle"><input type="checkbox" checked={form.ai_enabled} onChange={e => set('ai_enabled', e.target.checked)} /><span className="toggle-slider" /></span>
                  <span style={{ fontWeight: 600 }}>Yapay zeka modu</span>
                </label>
                {form.ai_enabled && (
                  <div className="form-2" style={{ marginTop: 12 }}>
                    <div className="input-group" style={{ marginBottom: 0 }}><label>API key</label><input className="input" value={form.ai_api_key} onChange={e => set('ai_api_key', e.target.value)} placeholder="hf_…" /></div>
                    <div className="input-group" style={{ marginBottom: 0 }}><label>Model</label><input className="input" value={form.ai_model} onChange={e => set('ai_model', e.target.value)} placeholder="mistralai/…" /></div>
                  </div>
                )}
              </div>

              <div className="flex gap-8" style={{ justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-ghost" onClick={() => setShowForm(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">{editBot ? 'Güncelle' : 'Ekle'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
